// extracted by mini-css-extract-plugin
export default {"item":"UnloadingsItem_item__gQ6Rj","name":"UnloadingsItem_name__B7UbT","fileFormat":"UnloadingsItem_fileFormat__nT61c","dotsButton":"UnloadingsItem_dotsButton__aPMc2"};